export enum HolidayCountry {
    US = 'US',

    Canada = 'Canada'
}